import { jsxs as f, jsx as o } from "react/jsx-runtime";
import { c as y } from "./clsx-OuTLNxxd.js";
import { I as _ } from "./icon-OnwLrJ7B.js";
import "./components/elements/icon/iconsList.js";
import { Loader as b } from "./components/elements/loader/loader.js";
const v = "_button_mgunx_1", w = "_disabled_mgunx_18", s = {
  button: v,
  disabled: w,
  "is-primary": "_is-primary_mgunx_31",
  "is-secondary": "_is-secondary_mgunx_44",
  "is-tertiary": "_is-tertiary_mgunx_56",
  "is-eco-green": "_is-eco-green_mgunx_68",
  "is-white": "_is-white_mgunx_82",
  "is-ghost": "_is-ghost_mgunx_95",
  "is-destructive-ghost": "_is-destructive-ghost_mgunx_109",
  "is-destructive": "_is-destructive_mgunx_109",
  "is-facebook": "_is-facebook_mgunx_136",
  "is-apple": "_is-apple_mgunx_150",
  "is-google": "_is-google_mgunx_164",
  "is-collection": "_is-collection_mgunx_178",
  "is-regular": "_is-regular_mgunx_192",
  "is-medium": "_is-medium_mgunx_195",
  "is-small": "_is-small_mgunx_198",
  "is-full-width": "_is-full-width_mgunx_201"
};
function j({
  color: a = "primary",
  text: m,
  size: u = "regular",
  isFullWidth: g = !1,
  icon: i,
  iconPosition: e = "left",
  onClick: l,
  children: n,
  disabled: t,
  type: c = "button",
  className: d = "",
  href: r,
  isLoading: x,
  ...h
}) {
  const p = y(
    s.button,
    s[T[a]],
    s[k[u]],
    g && s["is-full-width"],
    t && s.disabled,
    e === "right" && s["has-icon-right"],
    d
  );
  return /* @__PURE__ */ f(
    `${r ? "a" : "button"}`,
    {
      href: t ? void 0 : r,
      onClick: l,
      className: p,
      disabled: t,
      type: c,
      ...h,
      children: [
        x && /* @__PURE__ */ o(b, { onDark: !0, size: "small" }),
        i && e === "left" && /* @__PURE__ */ o(_, { name: i }),
        n ?? m,
        i && e === "right" && /* @__PURE__ */ o(_, { name: i })
      ]
    }
  );
}
const T = {
  primary: "is-primary",
  secondary: "is-secondary",
  tertiary: "is-tertiary",
  "eco-green": "is-eco-green",
  white: "is-white",
  ghost: "is-ghost",
  "destructive-ghost": "is-destructive-ghost",
  destructive: "is-destructive",
  facebook: "is-facebook",
  apple: "is-apple",
  google: "is-google",
  collection: "is-collection"
}, k = {
  small: "is-small",
  medium: "is-medium",
  regular: "is-regular"
};
export {
  j as B,
  T as a,
  k as b
};
